<template>
  <div id="app">
    <!-- 顶部导航 -->
    <Header></Header>
    <!-- banner图 -->
    <div class="banner">
      <img src="./images/banner.png" alt="">
       <div class="bannerCon">
        <p class="bannerTitle">{{ copyData.spring.bannerTitleZH }}</p>
        <p class="bannerSubtitle">{{ copyData.spring.bannerTitleEN }}</p>
      </div>
    </div>
    <!-- 面包屑 -->
    <p class="breadcrumb">{{ copyData.spring.breadcrumb }}{{ breadcrumb }}</p>
    <!-- 主体部分 -->
    <div class="main">
      <!-- pc端导航栏 -->
      <div class="leftCon" v-if="windowWidth >= 800">
        <div class="titleCon">
          <p class="title">{{ copyData.spring.springTitleZH }}</p>
          <p class="titleEN">{{ copyData.spring.springTitleEN }}</p>
        </div>
        <div class="menuCon">
          <div class="menuList" :class="tabTag == 1 ? 'menuListAct' : ''" @click="tabTag = 1,breadcrumb = copyData.spring.menulist01,swiperIndex = -1,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.spring.menulist01 }}</p>
          </div>
          <div class="menuList" :class="tabTag == 2 ? 'menuListAct' : ''" @click="tabTag = 2,breadcrumb = copyData.spring.menulist02,swiperIndex = -1,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.spring.menulist02 }}</p>
          </div>
          <div class="menuList" :class="tabTag == 3 ? 'menuListAct' : ''" @click="tabTag = 3,breadcrumb = copyData.spring.menulist03,swiperIndex = -1,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.spring.menulist03 }}</p>
          </div>
          <div class="menuList" :class="tabTag == 4 ? 'menuListAct' : ''" @click="tabTag = 4,breadcrumb = copyData.spring.menulist04,swiperIndex = -1,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.spring.menulist04 }}</p>
          </div>
          <div class="menuList" :class="tabTag == 5 ? 'menuListAct' : ''" @click="tabTag = 5,breadcrumb = copyData.spring.menulist05,swiperIndex = -1,getPosition()">
            <img src="./images/arrow.png" alt="">
            <p>{{ copyData.spring.menulist05 }}</p>
          </div>
          <div class="phoneCon">
            <img src="./images/phone.png" alt="">
            <p>{{ copyData.spring.phoneTitle }}</p>
            <p class="phoneNum">{{ copyData.spring.phoneNum }}</p>
          </div>
        </div>
      </div>
      <!-- 移动端导航栏 -->
      <div class="leftCon" v-if="windowWidth < 800">
        <div class="menuCon">
          <div class="menuList" :class="tabTag == 1 ? 'menuListAct' : ''" @click="tabTag = 1,breadcrumb = copyData.spring.menulist01,swiperIndex = -1">
            <p>{{ copyData.spring.menulist01 }}</p>
          </div>
          <div class="menuList" :class="tabTag == 2 ? 'menuListAct' : ''" @click="tabTag = 2,breadcrumb = copyData.spring.menulist02,swiperIndex = -1">
            <p>{{ copyData.spring.menulist02 }}</p>
          </div>
          <div class="menuList" :class="tabTag == 3 ? 'menuListAct' : ''" @click="tabTag = 3,breadcrumb = copyData.spring.menulist03,swiperIndex = -1">
            <p>{{ copyData.spring.menulist03 }}</p>
          </div>
          <div class="menuList" :class="tabTag == 4 ? 'menuListAct' : ''" @click="tabTag = 4,breadcrumb = copyData.spring.menulist04,swiperIndex = -1">
            <p>{{ copyData.spring.menulist04 }}</p>
          </div>
          <div class="menuList" :class="tabTag == 5 ? 'menuListAct' : ''" @click="tabTag = 5,breadcrumb = copyData.spring.menulist05,swiperIndex = -1">
            <p>{{ copyData.spring.menulist05 }}</p>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="rightCon" v-if="tabTag == 1">
        <div class="mainCon" v-if="swiperIndex == -1">
          <p class="rightTitle">{{ copyData.spring.springTitleOne }}</p>
          <p class="rightText">{{ copyData.spring.springTextOne }}</p>
          <p class="rightTitle">{{ copyData.spring.springTitleTwo }}</p>
          <p class="rightText">{{ copyData.spring.springTextTwo }}</p>
          <div class="listCon">
            <div class="listMain" v-for="(item, index) in imgListOne" :key="index" @click="swiperIndex = index,getPosition()">
              <img :src="item.url" alt="">
            </div>
          </div>
        </div>
        <div class="swiper" v-if="swiperIndex != -1">
          <!-- <div class="return">
            <img src="./images/return.png" alt="" @click="swiperIndex = -1">
          </div> -->
          <el-carousel :height="windowWidth >= 800 ? '610px' : '62.24vw'" width="100%" indicator-position="none" arrow="always" :autoplay="false" :initial-index="swiperIndex">
            <el-carousel-item v-for="item in imgListOne" :key="item">
              <div class="swiperList">
                <img :src="item.url" alt="">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="rightCon" v-if="tabTag == 2">
        <div class="mainCon" v-if="swiperIndex == -1">
          <p class="rightTitle">{{ copyData.spring.springTitleOne }}</p>
          <p class="rightText">{{ copyData.spring.springTextThree }}</p>
          <p class="rightTitle">{{ copyData.spring.springTitleTwo }}</p>
          <p class="rightText">{{ copyData.spring.springTextFour }}</p>
          <div class="listCon">
            <div class="listMain" v-for="(item, index) in imgListTwo" :key="index" @click="swiperIndex = index,getPosition()">
              <img :src="item.url" alt="">
            </div>
          </div>
        </div>
        <div class="swiper" v-if="swiperIndex != -1">
          <!-- <div class="return">
            <img src="./images/return.png" alt="" @click="swiperIndex = -1">
          </div> -->
          <el-carousel :height="windowWidth >= 800 ? '610px' : '62.24vw'" width="100%" indicator-position="none" arrow="always" :autoplay="false" :initial-index="swiperIndex">
            <el-carousel-item v-for="item in swiperListTwo" :key="item">
              <div class="swiperList">
                <img :src="item.url" alt="">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="rightCon" v-if="tabTag == 3">
        <div class="mainCon" v-if="swiperIndex == -1">
          <p class="rightTitle">{{ copyData.spring.springTitleOne }}</p>
          <p class="rightText">{{ copyData.spring.springTextFive }}</p>
          <p class="rightTitle">{{ copyData.spring.springTitleTwo }}</p>
          <p class="rightText">{{ copyData.spring.springTextSix }}</p>
          <div class="listCon">
            <div class="listMain" v-for="(item, index) in imgListThree" :key="index" @click="swiperIndex = index,getPosition()">
              <img :src="item.url" alt="">
            </div>
          </div>
        </div>
        <div class="swiper" v-if="swiperIndex != -1">
          <!-- <div class="return">
            <img src="./images/return.png" alt="" @click="swiperIndex = -1">
          </div> -->
          <el-carousel :height="windowWidth >= 800 ? '610px' : '62.24vw'" width="100%" indicator-position="none" arrow="always" :autoplay="false" :initial-index="swiperIndex">
            <el-carousel-item v-for="item in imgListThree" :key="item">
              <div class="swiperList">
                <img :src="item.url" alt="">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="rightCon" v-if="tabTag == 4">
        <div class="mainCon" v-if="swiperIndex == -1">
          <p class="rightTitle">{{ copyData.spring.springTitleOne }}</p>
          <p class="rightText">{{ copyData.spring.springTextSeven }}</p>
          <p class="rightTitle">{{ copyData.spring.springTitleTwo }}</p>
          <p class="rightText">{{ copyData.spring.springTextEight }}</p>
          <div class="listCon">
            <div class="listMain" v-for="(item, index) in imgListFour" :key="index" @click="swiperIndex = index,getPosition()">
              <img :src="item.url" alt="">
            </div>
          </div>
        </div>
        <div class="swiper" v-if="swiperIndex != -1">
          <el-carousel :height="windowWidth >= 800 ? '610px' : '62.24vw'" width="100%" indicator-position="none" arrow="always" :autoplay="false" :initial-index="swiperIndex">
            <el-carousel-item v-for="item in swiperListFour" :key="item">
              <div class="swiperList">
                <img :src="item.url" alt="">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="rightCon" v-if="tabTag == 5">
        <div class="mainCon" v-if="swiperIndex == -1">
          <p class="rightTitle">{{ copyData.spring.springTitleOne }}</p>
          <p class="rightText">{{ copyData.spring.springTextNine }}</p>
          <p class="rightTitle">{{ copyData.spring.springTitleTwo }}</p>
          <p class="rightText">{{ copyData.spring.springTextNine }}</p>
          <div class="listCon">
            <div class="listMain" v-for="(item, index) in imgListFive" :key="index" @click="swiperIndex = index,getPosition()">
              <img :src="item.url" alt="">
            </div>
          </div>
        </div>
        <div class="swiper" v-if="swiperIndex != -1">
          <!-- <div class="return">
            <img src="./images/return.png" alt="" @click="swiperIndex = -1">
          </div> -->
          <el-carousel :height="windowWidth >= 800 ? '610px' : '62.24vw'" width="100%" indicator-position="none" arrow="always" :autoplay="false" :initial-index="swiperIndex">
            <el-carousel-item v-for="item in swiperListFive" :key="item">
              <div class="swiperList">
                <img :src="item.url" alt="">
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 底部导航 -->
    <Footer></Footer>
    <div class="scroll-top" @click="backToTop">
      <img src="./images/backTop.png">
    </div>
  </div>
</template>

<script>
  import 'common/css/reset.css';
  import {defineComponent, ref, reactive, onMounted} from "vue";
  import Footer from 'components/Footer/Footer'
  import Header from 'components/Header/Header'
  import { chinese } from "src/language/zh.js";
  import { english } from "src/language/en.js";

  export default defineComponent({
    name: 'app',
    components: {
      Footer,
      Header,
    },

    setup() {
      const copyData = ref({})
      const breadcrumb = ref('压簧系列')

      const tabTag = ref(1)
      // 获取当前语言
      const getLanguage = () => {
        copyData.value = chinese
      }
      // 获取当前屏幕的宽度
      const windowWidth = ref(document.body.clientWidth);
      const swiperIndex = ref(-1)
      const imgListOne = [
        {url: require('./images/101.png')},
        {url: require('./images/102.png')},
        {url: require('./images/103.png')},
        {url: require('./images/104.png')},
        {url: require('./images/105.png')},
        {url: require('./images/106.png')},
        {url: require('./images/107.png')},
        {url: require('./images/108.png')},
        {url: require('./images/109.png')},
        {url: require('./images/110.png')},
        {url: require('./images/111.png')},
        {url: require('./images/112.png')},
        {url: require('./images/113.png')},
      ];

      const imgListTwo = [
        {url: require('./images/201.png')},
        {url: require('./images/202.png')},
        {url: require('./images/203.png')},
        {url: require('./images/204.png')},
        {url: require('./images/205.png')},
        {url: require('./images/206.png')},
        {url: require('./images/207.png')},
        {url: require('./images/208.png')},
        {url: require('./images/209.png')},
        {url: require('./images/210.png')},
      ];

      const imgListThree = [
        {url: require('./images/305.png')},
        {url: require('./images/302.png')},
        {url: require('./images/303.png')},
        {url: require('./images/304.png')},
        {url: require('./images/301.png')},
        {url: require('./images/306.png')},
        {url: require('./images/307.png')},
        {url: require('./images/308.png')},
        {url: require('./images/309.png')},
        {url: require('./images/310.png')},
      ];

      const imgListFour = [
        {url: require('./images/401.png')},
        {url: require('./images/402.png')},
        {url: require('./images/403.png')},
        {url: require('./images/404.png')},
        {url: require('./images/405.png')},
        {url: require('./images/406.png')},
        {url: require('./images/407.png')},
        {url: require('./images/408.png')},
        {url: require('./images/409.png')},
        {url: require('./images/410.png')},
      ];

      const imgListFive = [
        {url: require('./images/501.png')},
        {url: require('./images/502.png')},
        {url: require('./images/503.png')},
        {url: require('./images/504.png')},
        {url: require('./images/505.png')},
        {url: require('./images/506.png')},
        {url: require('./images/507.png')},
        {url: require('./images/508.png')},
        {url: require('./images/509.png')},
        {url: require('./images/510.png')},
      ];

      const swiperListTwo = [
        {url: require('./images/s201.png')},
        {url: require('./images/s202.png')},
        {url: require('./images/s203.png')},
        {url: require('./images/s204.png')},
        {url: require('./images/s205.png')},
        {url: require('./images/s206.png')},
        {url: require('./images/s207.png')},
        {url: require('./images/s208.png')},
        {url: require('./images/s209.png')},
        {url: require('./images/s210.png')},
      ];

      const swiperListFour = [
        {url: require('./images/s401.png')},
        {url: require('./images/s402.png')},
        {url: require('./images/s403.png')},
        {url: require('./images/s404.png')},
        {url: require('./images/s405.png')},
        {url: require('./images/s406.png')},
        {url: require('./images/s407.png')},
        {url: require('./images/s408.png')},
        {url: require('./images/s409.png')},
        {url: require('./images/s410.png')},
      ];

      const swiperListFive = [
        {url: require('./images/s501.png')},
        {url: require('./images/s502.png')},
        {url: require('./images/s503.png')},
        {url: require('./images/s504.png')},
        {url: require('./images/s505.png')},
        {url: require('./images/s506.png')},
        {url: require('./images/s507.png')},
        {url: require('./images/s508.png')},
        {url: require('./images/s509.png')},
        {url: require('./images/s510.png')},
      ];

      // 页面定位到指定位置
      const getPosition = () => {
        if (windowWidth.value >= 800) {
          if(document.body.scrollTop > 750 || document.documentElement.scrollTop > 750) {
            document.body.scrollTop = 750;
            document.documentElement.scrollTop = 750;
          }
        } else {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      };

      const goBackToTop = () => {
        window.addEventListener('scroll', (e) => {
          // handleShowTop()
        })
        // handleShowTop()


      }

      const handleShowTop = () => {
        let sc = window.scrollY
        if (sc > 100) {
          document.querySelector('.scroll-top').classList.add('show')
        } else {
          document.querySelector('.scroll-top').classList.remove('show')
        }
      }

      const backToTop = () => {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
      }

      onMounted(() => {
        goBackToTop()
      });

      getLanguage()
      breadcrumb.value = copyData.value.spring.menulist01;
      return {
        chinese,
        english,
        copyData,
        getLanguage,
        windowWidth,
        breadcrumb,
        tabTag,
        imgListOne,
        swiperIndex,
        imgListTwo,
        imgListThree,
        imgListFour,
        imgListFive,
        swiperListTwo,
        swiperListFour,
        swiperListFive,
        getPosition,
        goBackToTop,
        backToTop
      }
    }
  })
</script>

<style scoped lang="less">
// 电脑端样式
  #app {
    font-family: 'SourceHanSansCN','Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* margin-top: 60px; */
    overflow-x: hidden;
    p {
      margin: 0;
    }

    .scroll-top {
      display: none;

      &.show {
        position: fixed;
        right: 20px;
        bottom: 100px;
        background: rgba(0,0,0,.4);
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img{
          width: 40px;
          height: 40px;
        }
      }
    }

    .banner {
      width: 100%;
      position: relative;
      z-index: -1;

      img {
        width: 100%;
        height: auto;
      }

      .bannerCon {
        width: 1200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: right;
        padding-right: 150px;


        .bannerTitle {
          font-size: 60px;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #FFFFFF;
        }

        .bannerSubtitle {
          font-size: 24px;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #FFFFFF;
          opacity: 0.5;
          margin-top: 17px;
        }
      }
    }

    .breadcrumb {
      width: 1200px;
      text-align: left;
      font-size: 14px;
      font-family: 'SourceHanSansCN';
      font-weight: 400;
      color: #898989;
      margin: 20px auto 50px;
    }

    .main {
      width: 1200px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin: 0 auto;
      .leftCon {
        width: 270px;
        height: 620px;
        margin-right: 50px;
        .titleCon {
          width: 100%;
          height: 100px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background: #0068B7;

          .title {
            font-size: 24px;
            font-family: 'SourceHanSansCN';
            font-weight: bold;
            color: #FFFFFF;
            margin: 0;
          }

          .titleEN {
            font-size: 12px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #FFFFFF;
            opacity: 0.5;
            margin: 5px 0 0;
          }
        }

        .menuCon {
          width: 270px;
          height: 510px;
          box-sizing: border-box;
          padding-top: 20px;
          border: 1px solid hsla(240, 1%, 71%, 0.5);
          border-top: none;

          .menuList {
            width: 220px;
            border-bottom: 1px solid hsla(240, 1%, 71%, 0.5);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 16px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #595757;
            cursor: pointer;
            margin: 0 auto;

            p {
              margin: 20px 0;
              text-align: left;
              line-height: 25px;
            }

            img {
              margin-right: 17px;
              width: 24px;
              height: 24px;
            }
          }
          .menuList:hover {
            color: #0068B7;
          }
          .menuListAct {
            color: #0068B7;
          }

          .phoneCon {
            width: 220px;
            position: relative;
            font-size: 16px;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #595757;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin: 10px auto 0;

            p {
              margin: 18px 0;
            }

            img {
              margin-right: 17px;
              width: 24px;
              height: 24px;
            }

            .phoneNum {
              font-size: 24px;
              font-family: 'SourceHanSansCN';
              font-weight: bold;
              color: #0068B7;
              position: absolute;
              left: 30px;
              top: 45px;
              width: 200px;
              margin: 0;
            }
          }
        }
      }

      .rightCon {
        width: 882px;
        margin-bottom: 160px;

        .rightTitle {
          font-size: 24px;
          font-weight: bold;
          color: #595757;
          margin: 30px 0;
        }

        .rightText {
          font-size: 20px;
          font-weight: 400;
          color: #595757;
          line-height: 30px;
          text-indent: 2em;
          text-align: justify;
          letter-spacing: 2px;
        }

        .listCon {
          width: 882px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-start;
          margin-top: 30px;

          .listMain {
            width: 282px;
            height: 282px;
            position: relative;
            overflow: hidden;
            margin-bottom: 20px;
            cursor: pointer;

            img {
              width: 100%;
              height: auto;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              transition: width 0.3s;
            }

            img:hover {
              width: 110%;
              height: auto;
              transition: width 0.3s;
            }
          }

          .listMain:nth-last-of-type(1) {
            width: 880px;
            height: 1034px;
          }
        }

        .swiper {
          width: 882px;

          .return {
            width: 100%;
            height: auto;
            margin-bottom: 50px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;

            img {
              width: 20px;
              height: auto;
              cursor: pointer;
            }
          }

          .swiperList {
            height: 610px;
            width: 882px;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: auto;
              height: 100%;
            }
          }
        }
      }
    }
  }

html[lang="en"] {
  #app {
    .main {
      .rightCon{
        .rightText{
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0;
          font-family: 'SourceHanSansCN';
          text-align: left;
        }
      }

      .leftCon{
        .menuCon{
          height:556px;

          .menuList{
            font-size: 14px;
          }

          .phoneCon {
            font-size: 14px;

            .phoneNum{
              font-size: 22px;
              text-align: left;
            }

            img{
              margin-right: 9px;
              width: 22px;
              height: 22px;
            }
          }
        }
      }
    }
  }
}

// 手机端样式
@media screen and (max-width: 900px) {
  #app {
    font-family: 'SourceHanSansCN','Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;

    p {
      margin: 0;
    }

    .banner {
      width: 100%;
      height: 55vw;
      overflow: hidden;
      position: relative;

      img {
        width: auto;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
      }

      .bannerCon {
        width: 70vw;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: right;
        padding-right: 0;

        .bannerTitle {
          font-size: 5.3vw;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #FFFFFF;
        }

        .bannerSubtitle {
          font-size: 3.2vw;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #FFFFFF;
          opacity: 0.5;
          margin-top: 2vw;
        }
      }
    }

    .breadcrumb {
      width: 90vw;
      text-align: left;
      font-size: 3.2vw;
      font-family: 'SourceHanSansCN';
      font-weight: 400;
      color: #898989;
      margin: 3vw auto 3vw;
    }

    .main {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      margin: 0 auto;

      .leftCon {
        width: 100%;
        margin-right: 0px;
        height: auto;
        margin-bottom: 0vw;
        overflow-x: scroll;

        .menuCon {
          width: 150vw;
          height: 12vw;
          box-sizing: border-box;
          padding-top: 0px;
          border: 1px solid hsla(240, 1%, 71%, 0.5);
          border-left: none;
          border-right: none;
          display: flex;
          flex-wrap: nowrap;
          justify-content: center;
          align-items: center;

          .menuList {
            width: auto;
            border-bottom: none;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 3.8vw;
            font-family: 'SourceHanSansCN';
            font-weight: 400;
            color: #595757;
            cursor: pointer;
            margin: 0 auto;
            padding: 0 2vw;

            p {
              margin: 0;
            }
          }
          .menuList:hover {
            color: #0068B7;
          }
          .menuListAct {
            color: #0068B7;
          }
        }
      }

      // 去除滚动条样式
      ::-webkit-scrollbar {
        width: 0px;
      }

      .rightCon {
        width: 90vw;
        margin-bottom: 10vw;

        .rightTitle {
          font-size: 5vw;
          font-family: 'SourceHanSansCN';
          font-weight: bold;
          color: #595757;
          margin: 2vw 0;
        }

        .rightText {
          font-size: 3.5vw;
          font-family: 'SourceHanSansCN';
          font-weight: 400;
          color: #595757;
          line-height: 5.5vw;
          text-indent: 2em;
          text-align: justify;
        }

        .listCon {
          width: 90vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-start;
          margin-top: 4vw;

          .listMain {
            width: 28vw;
            height: 28vw;
            position: relative;
            overflow: hidden;
            margin-bottom: 20px;
            cursor: pointer;

            img {
              width: 100%;
              height: auto;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              transition: width 0.3s;
            }

            img:hover {
              width: 110%;
              height: auto;
              transition: width 0.3s;
            }
          }

          .listMain:nth-child(10) {
            width: 90vw;
            height: 105.75vw;
          }
        }

        .swiper {
          width: 90vw;

          .return {
            width: 100%;
            height: auto;
            margin-bottom: 5vw;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;

            img {
              width: 4vw;
              height: auto;
              cursor: pointer;
            }
          }

          .swiperList {
            width: 90vw;
            height: 62.24vw;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              height: 100%;
            }
          }
        }
      }

    }
  }

  html[lang="en"] {
    #app {
      .main {

        .leftCon{
          .menuCon{
            .menuList{
              width: 220px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?3b6d0815